import { isBrowser } from "appConfiguration";

export async function copyTextToClipboard(text: string): Promise<void> {
  if (isBrowser) {
    await navigator.clipboard.writeText(text);
  }
}
